import { Controller } from '@hotwired/stimulus'
import { createApp } from '@app/adapters/create-app'
import DatePicker from '@app/shared/vue/components/form/date-picker.vue'

export default class extends Controller {
  static values = {
    name: String,
    value: String,
    placeholder: String,
    disabled: Boolean,
    dateFormat: String,
  }

  declare nameValue: string
  declare valueValue: string
  declare placeholderValue: string
  declare disabledValue: boolean
  declare dateFormatValue: string

  connect(): void {
    createApp(DatePicker, {
      name: this.nameValue,
      modelValue: this.valueValue,
      placeholder: this.placeholderValue,
      disabled: this.disabledValue,
      icon: true,
      options: {
        dateFormat: this.dateFormatValue || 'd/m/Y',
        allowInput: true,
      },
    }).mount(this.element)
  }
}
